import $ from 'jquery'
import 'foundation-sites'
import './application.scss'

document.addEventListener('DOMContentLoaded', () => {
  $(document).foundation();
});
